import React, { useEffect, useState } from "react";
import { initEventSource, NotificationData } from "utils/eventSource";

const NotificationListener: React.FC = () => {
    const [notifications, setNotifications] = useState<NotificationData[]>([]);

    useEffect(() => {
        const channel = initEventSource();

        channel.onmessage = (event: MessageEvent) => {
            if (event.data === "leader_down" || event.data === "iam_leader") {
                return;
            }
            const data: NotificationData = event.data.data;
            setNotifications((prev) => [...prev, data]);
        };

        return () => {
            channel.close();
        };
    }, []);

    return (
        <div>
            <h2>Thông báo realtime</h2>
            <ul>
                {notifications.map((m: any) => (
                    <li key={m.id} className="shadow mb-2 p-2 rounded flex">
                        <div className="flex-1">
                            <div className="bold">{m.notification.title}</div>
                            <div>{m.notification.body}</div>
                        </div>
                        <div>{m.created_at}</div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default NotificationListener;